import { IconContext } from "@phosphor-icons/react";
import type { ReactNode } from "react";

const ICON_DEFAULTS = { weight: "regular", size: 20, mirrored: false } as const;

/** Define o peso regular (traço único) como padrão de todos os ícones Phosphor da árvore. */
export function IconProvider({ children }: { children: ReactNode }) {
  return <IconContext.Provider value={ICON_DEFAULTS}>{children}</IconContext.Provider>;
}
